export default __webpack_public_path__ + "d4a0b5a1138b0d38eb9ebca254ac21fa.png";